export const WPCLOUD_WIDGETS_FALLBACK_URL = '/widgets';
export const WPCLOUD_WIDGET_PROXY_URL =
	'https://public-api.wordpress.com/wpcom/v2/host-partners';

export type WPCloudAtomicMetricsConfig = {
	authToken?: string;
	onBarLabelClick?: ( label: string, value: number, event?: MouseEvent ) => void;
	[ key: string ]: unknown;
};

declare global {
	interface Window {
		__hppConfig?: {
			widgetsUrl?: string;
			widgetsVersion?: string | number | null;
		};
		AtomicMetricsConfig?: WPCloudAtomicMetricsConfig;
	}
}

export function getWPCloudWidgetsUrl() {
	if ( typeof window === 'undefined' ) {
		return WPCLOUD_WIDGETS_FALLBACK_URL;
	}

	return window.__hppConfig?.widgetsUrl ?? WPCLOUD_WIDGETS_FALLBACK_URL;
}

export function getWPCloudWidgetsVersion(): string | null {
	if ( typeof window === 'undefined' ) {
		return null;
	}
	const v = window.__hppConfig?.widgetsVersion;
	return v === undefined || v === null || v === '' ? null : String( v );
}

function withWidgetsVersion( url: string ): string {
	const version = getWPCloudWidgetsVersion();
	if ( ! version ) {
		return url;
	}
	const separator = url.includes( '?' ) ? '&' : '?';
	return `${ url }${ separator }ver=${ encodeURIComponent( version ) }`;
}

export function ensureWPCloudWidgetRuntime() {
	if ( typeof document === 'undefined' ) {
		return;
	}

	const widgetsUrl = getWPCloudWidgetsUrl();

	if ( ! document.getElementById( 'atomic-metrics-css' ) ) {
		const link = document.createElement( 'link' );
		link.id = 'atomic-metrics-css';
		link.rel = 'stylesheet';
		link.href = withWidgetsVersion( `${ widgetsUrl }/css/widgets.css` );
		document.head.appendChild( link );
	}

	if ( ! document.getElementById( 'atomic-metrics-runtime' ) ) {
		const script = document.createElement( 'script' );
		script.id = 'atomic-metrics-runtime';
		script.type = 'module';
		script.src = withWidgetsVersion( `${ widgetsUrl }/js/runtime.js` );
		document.head.appendChild( script );
	}
}

export function setWPCloudWidgetAuthToken( accessToken?: string | null ) {
	if ( ! accessToken || typeof window === 'undefined' ) {
		return;
	}

	window.AtomicMetricsConfig = {
		...( window.AtomicMetricsConfig ?? {} ),
		authToken: accessToken,
	};
}

export function getWPCloudAtomicClientId(
	search: URLSearchParams = new URLSearchParams(
		typeof window === 'undefined' ? '' : window.location.search
	)
) {
	const atomicClientId = Number( search.get( 'atomic_client_id' ) );
	return Number.isFinite( atomicClientId ) && atomicClientId > 0
		? atomicClientId
		: null;
}

export function buildWPCloudWidgetProxyUrl( atomicClientId?: number | null ) {
	return atomicClientId
		? `${ WPCLOUD_WIDGET_PROXY_URL }/for/${ atomicClientId }`
		: WPCLOUD_WIDGET_PROXY_URL;
}
